/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Sent_Go_To_FilesInputs */

const en_common_sent_go_to_files = /** @type {(inputs: Common_Sent_Go_To_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sent! Go to my files`)
};

const es_common_sent_go_to_files = /** @type {(inputs: Common_Sent_Go_To_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Enviado! Ir a mis archivos`)
};

/**
* | output |
* | --- |
* | "Sent! Go to my files" |
*
* @param {Common_Sent_Go_To_FilesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_sent_go_to_files = /** @type {((inputs?: Common_Sent_Go_To_FilesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sent_Go_To_FilesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_sent_go_to_files(inputs)
	return en_common_sent_go_to_files(inputs)
});